import axios from "axios";

// Prefer the env-configured backend; fall back to the same origin so that
// Netlify's _redirects proxy at /api/* handles routing.  Never let the
// API path become "undefined/api" which silently breaks production.
const RAW = (process.env.REACT_APP_BACKEND_URL || "").trim();
const BACKEND_URL = RAW.replace(/\/+$/, ""); // strip trailing slash
export const API = BACKEND_URL ? `${BACKEND_URL}/api` : "/api";

export const api = axios.create({
    baseURL: API,
    headers: { "Content-Type": "application/json" },
    timeout: 15000,
});

export async function joinWaitlist(payload) {
    const { data } = await api.post("/waitlist", payload);
    return data;
}

export async function getWaitlistStats() {
    const { data } = await api.get("/waitlist/stats");
    return data;
}
